export default __webpack_public_path__ + "static/prepagas_desktop-c5bdc69c204c283f401fe7273a575d1a.jpg";